/* eslint-disable no-unused-vars */
export enum ScreenEnum {
  Overview = 'OVERVIEW',
  Advisories = 'ADVISORIES',
  CareAreas = 'CARE_AREAS',
}
